import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import { SupabaseProvider } from './contexts/SupabaseContext';
import { AppRouter } from './components/routing/AppRouter';
import './index.css';

// Check for required environment variables
if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  const missingVars = [];
  if (!import.meta.env.VITE_SUPABASE_URL) missingVars.push('VITE_SUPABASE_URL');
  if (!import.meta.env.VITE_SUPABASE_ANON_KEY) missingVars.push('VITE_SUPABASE_ANON_KEY');
  
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <div style={{ 
      fontFamily: 'Inter, system-ui, sans-serif', 
      padding: '2rem', 
      textAlign: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ 
        background: 'white', 
        padding: '2rem', 
        borderRadius: '1rem',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px'
      }}>
        <h1 style={{ color: '#ef4444', marginBottom: '1rem' }}>Configuration Error</h1>
        <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
          Missing required environment variables:
        </p>
        <ul style={{ 
          listStyle: 'none', 
          padding: 0, 
          marginBottom: '1rem',
          color: '#374151'
        }}>
          {missingVars.map(varName => (
            <li key={varName} style={{ 
              background: '#f3f4f6', 
              padding: '0.5rem', 
              margin: '0.25rem 0',
              borderRadius: '0.375rem',
              fontFamily: 'monospace'
            }}>
              {varName}
            </li>
          ))}
        </ul>
        <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
          Please check your .env file and restart the development server.
        </p>
      </div>
    </div>
  );
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <SupabaseProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </SupabaseProvider>
    </React.StrictMode>
  );
}
